<typography variant="p/sm_semibold" class="source-bar__title">
	{{ title }}
</typography>
<div class="source-bar__track">
	<div
		class="source-bar__segment"
		*ngFor="let item of items"
		[style.width.%]="item.percentage"
		[style.background]="item.color"
	></div>
</div>
<chart-legend [options]="legendOptions"></chart-legend>
